/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import { Table } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getAppSearchParams } from 'src/workspace/utils';
import EmptyState from '../components/emptyState';
import ErrorState from '../components/errorState';
import { keyMetricDetailsNavigation } from '../queries';
import { getKeyMetricsMetadata, getStatus } from '../selector';
import { fetchKeyMetricsMetadata } from '../thunk';
import { fetchLeadKeyMetricsMetadata } from '../widget/thunk';
import { keyMetricsColumns, keyMetricsTablePageSize } from './constants';
import styles from './index.module.scss';

function KeyMetricsTable({ cards = [], filters = [] }: any) {
  const dispatch = useAppDispatch();
  const keyMetricsMetadata = useAppSelector(getKeyMetricsMetadata);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [activeCards, setActiveCards] = useState<any>([]);
  const metadataStatus = useAppSelector((state) =>
    getStatus(state, 'key_metrics_metadata'),
  );
  const params = getAppSearchParams();
  const totalPages = Math.ceil(Number(cards.length) / keyMetricsTablePageSize);

  useEffect(() => {
    if (activeCards?.length) {
      if (params.source === 'vo') {
        dispatch(
          fetchLeadKeyMetricsMetadata({ cards: activeCards, params, filters }),
        );
      } else {
        dispatch(fetchKeyMetricsMetadata({ cards: activeCards }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCards]);

  useEffect(() => {
    setActiveCards(
      cards.slice(
        keyMetricsTablePageSize * (currentPage - 1),
        keyMetricsTablePageSize * currentPage,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  return (
    <>
      {metadataStatus === 'loading' && <SkeletonLoader height={300} rect />}
      {Boolean(!cards.length && metadataStatus === 'done') && <EmptyState />}
      {Boolean(metadataStatus === 'error') && <ErrorState />}
      {Boolean(cards.length && metadataStatus === 'done') && (
        <Table
          tableData={(keyMetricsMetadata || []).map((metric, index) => ({
            id:
              `${metric?.code}_${index}` ||
              metric?.code ||
              metric?.card?.goal_definition_code,
            ...metric,
          }))}
          columnConfigs={keyMetricsColumns}
          isAccordion={false}
          tableConfig={{
            name: '',
            hideColumnConfigurator: true,
            onRowClick: (_, row) => {
              const isDrilldownDisabled =
                row?.data?.body?.result?.group_by_key?.disable_drilldown;
              if (!isDrilldownDisabled) {
                keyMetricDetailsNavigation({
                  params: {
                    frequency: row?.card?.frequency ?? '',
                    start_date: row?.card?.date_range?.start ?? '',
                    title: row?.card?.title,
                  },
                  code: row?.code,
                  dispatch,
                });
              }
            },
          }}
        />
      )}

      {Boolean(metadataStatus === 'done' && totalPages > 1) && (
        <div className={styles.wrapper__paginationBtns}>
          {currentPage > 1 && (
            <Button
              size="small"
              type="outlined"
              rounded
              onClick={() => {
                setCurrentPage((prev) => prev - 1);
              }}
            >
              {locale(Keys.VIEW_PREVIOUS_METRICS)}
            </Button>
          )}
          {currentPage < totalPages && (
            <Button
              size="small"
              type="outlined"
              rounded
              onClick={() => {
                setCurrentPage((prev) => prev + 1);
              }}
            >
              {locale(Keys.VIEW_NEXT_METRICS)}{' '}
            </Button>
          )}
        </div>
      )}
    </>
  );
}

export default KeyMetricsTable;
